export function PrivacyPolicy({ onClose }: { onClose: () => void }) {
  return (
    <div className="privacy-overlay">
      <main className="privacy-sheet">
        <h1>Privacy Policy</h1>
        <p className="privacy-updated">Last Updated: July 10, 2026</p>

        <p>
          Welcome to Labyrinthine Software Inc. (“we,” “our,” or “us”). We value
          your privacy. This Privacy Policy explains how we collect, use, and
          protect your information when you visit our landing page and join our
          waitlist.
        </p>

        <h2>1. Information We Collect</h2>
        <ul>
          <li>
            <strong>Voluntary Information:</strong> When you join our waitlist,
            we collect your email address.
          </li>
          <li>
            <strong>Automated Information:</strong> We use privacy-friendly
            analytics tools to collect basic, non-identifying data (like your
            browser type and general location) to understand how visitors use
            our site.
          </li>
        </ul>

        <h2>2. How We Use Your Data</h2>
        <p>We use your email address exclusively to:</p>
        <ul>
          <li>Manage our product waitlist and secure your spot.</li>
          <li>
            Send you project updates, launch announcements, and occasional
            feedback surveys.
          </li>
        </ul>
        <p>
          We will <strong>never</strong> sell, rent, or trade your email address
          to third parties.
        </p>

        <h2>3. Data Storage and Third Parties</h2>
        <p>
          Your data is securely stored using reputable, third-party email
          service providers. These providers are strictly prohibited from using
          your data for any purpose other than helping us send you our updates.
        </p>

        <h2>4. Your Rights and Opting Out</h2>
        <p>You control your data. At any time, you can:</p>
        <ul>
          <li>
            <strong>Unsubscribe:</strong> Click the “Unsubscribe” link at the
            bottom of any email we send to stop receiving updates.
          </li>
          <li>
            <strong>Be Forgotten:</strong> Email us at{' '}
            <a href="mailto:privacy@labyrinthine.ai">privacy@labyrinthine.ai</a>{' '}
            to request that we permanently delete your email address from our
            database.
          </li>
        </ul>

        <h2>5. Updates to This Policy</h2>
        <p>
          We may update this policy as our product evolves. If we make major
          changes, we will notify you via the email address you provided.
        </p>

        <h2>Contact Us</h2>
        <p>
          If you have any questions about this policy, please reach out to us at{' '}
          <a href="mailto:privacy@labyrinthine.ai">privacy@labyrinthine.ai</a>.
        </p>

        <a
          className="privacy-back"
          href="/"
          onClick={(event) => {
            event.preventDefault();
            onClose();
          }}
        >
          ← Back to Codify
        </a>
      </main>
    </div>
  );
}
